import axios from 'axios';
import Utils from 'utils';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://api.pushpulse.io/'

axios.interceptors.response.use(undefined, (error) => {
  const errors = error?.response?.data;
  /*
  Handle errors like 404, 405, 403, and Networking issues
  */
  throw errors;
});

const responseData = (response) => response.data;
const requestHeaders = (protectedRoute, formData) => {
  let headers = {}
  headers['Accept'] = 'application/json';
  if (protectedRoute) {
    headers['Authorization'] = `Bearer ${Utils.getSessionToken()}`;
  }
  if (formData) {
    headers['Content-Type'] = 'multipart/form-data';
  }
  return {
    headers
  };
} 
const http_requests = {
  get: (protectedRoute, url) => axios.get(url, requestHeaders(protectedRoute)).then(responseData),
  post: (protectedRoute, url, data) => axios.post(url, data, requestHeaders(protectedRoute)).then(responseData),
  delete: (protectedRoute, url) => axios.delete(url, requestHeaders(protectedRoute)).then(responseData),
  put: (protectedRoute, url, data) => axios.put(url, data, requestHeaders(protectedRoute)).then(responseData),
  postFormData: (protectedRoute, url, data) => axios.post(url, data, requestHeaders(protectedRoute, true))
  /*
  postFormData: (protectedRoute, url, file) => {
    var formData = new FormData();
    formData.append('file', file);
    return axios.post(url, formData, requestHeaders(protectedRoute, true))
  },
  postFormDataPrepared: (protectedRoute, url, object) => axios.post(url, object, requestHeaders(protectedRoute, true))
  */
}

export const auth = {
  register: (params) => http_requests.post(false, `${baseUrl}v1/auth/register`, params),
  login: (params) => http_requests.post(false, `${baseUrl}v1/auth/login`, params),
  logout: () => http_requests.delete(true, `${baseUrl}v1/auth/logout`),
}

export const user = { 
  details: () => http_requests.get(true, `${baseUrl}v1/user`),
  accounts: () => http_requests.get(true, `${baseUrl}v1/user/accounts`),
}

export const account = {
  details: () => http_requests.get(true, `${baseUrl}v1/account`),
}


///////////////////////////
// legacy
///////////////////////////
export const user1 = {

  forgotPassword: (params) => http_requests.post(false, `${baseUrl}v1/user/forgot-password`, params),
  resetPassword: (params) => http_requests.post(false, `${baseUrl}v1/user/reset-password`, params),
  confirmUser: (token) => http_requests.get(false, `${baseUrl}v1/user/confirm?token=${token}`),
  resendConfirmationEmail: (params) => http_requests.put(true, `${baseUrl}v1/user/confirm`, params),
  editEmail: (params) => http_requests.put(true, `${baseUrl}v1/user/settings/security/email`, params),
  cancelEditEmail: () => http_requests.delete(true, `${baseUrl}v1/user/settings/security/email`),
  editEmailResend: (params) => http_requests.put(true, `${baseUrl}v1/user/settings/security/email/resend`, params),
  changePassword: (params) => http_requests.put(true, `${baseUrl}v1/user/settings/security/password`, params),
  sessions: () => http_requests.delete(true, `${baseUrl}v1/user/settings/security/sessions`),
  details: () => http_requests.get(true, `${baseUrl}v1/user`),
  accounts: () => http_requests.get(true, `${baseUrl}v1/user/accounts`),
  profile: () => http_requests.get(true, `${baseUrl}v1/user/settings/profile`),
  notificationSettings: () => http_requests.get(true, `${baseUrl}v1/user/settings/notifications`),
  updateNotificationSettings: (params) => http_requests.put(true, `${baseUrl}v1/user/settings/notifications`, params),
  updateProfile: (params) => http_requests.put(true, `${baseUrl}v1/user/settings/profile`, params),
  uploadProfileImage: (file) => http_requests.postFormData(true, `${baseUrl}v1/user/settings/profile/image`, file),
  deleteProfileImage: () => http_requests.delete(true, `${baseUrl}v1/user/settings/profile/image`),
}

export const account1 = {
  details: () => http_requests.get(true, `${baseUrl}v1/account`),
  onboarding: (params) => http_requests.put(true, `${baseUrl}v1/account/onboarding`, params),
  branding: () => http_requests.get(true, `${baseUrl}v1/account/settings/branding`),
  updateBranding: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/branding`, params),
  uploadDarkLogo: (file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/branding/dark-logo`, file),
  deleteDarkLogo: () => http_requests.delete(true, `${baseUrl}v1/account/settings/branding/dark-logo`),
  uploadLightLogo: (file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/branding/light-logo`, file),
  deleteLightLogo: () => http_requests.delete(true, `${baseUrl}v1/account/settings/branding/light-logo`),
  uploadFavicon: (file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/branding/favicon`, file),
  deleteFavicon: () => http_requests.delete(true, `${baseUrl}v1/account/settings/branding/favicon`),
  scheduleSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/schedule`),
  updateScheduleSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/schedule`, params),
  profile: () => http_requests.get(true, `${baseUrl}v1/account/settings/profile`),
  updateProfile: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/profile`, params),
  regionalSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/regional`),
  updateRegionalSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/regional`, params),

  license: () => http_requests.get(true, `${baseUrl}v1/account/settings/license-insurance`),
  updateLicenseSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/license-insurance`, params),
  uploadLicenseDocument: (file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/license-insurance/license-document`, file),
  deleteLicenseDocument: () => http_requests.delete(true, `${baseUrl}v1/account/settings/license-insurance/license-document`),
  uploadInsuranceDocument: (file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/license-insurance/insurance-document`, file),
  deleteInsuranceDocument: () => http_requests.delete(true, `${baseUrl}v1/account/settings/license-insurance/insurance-document`),

  requestSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/requests`),
  getRequestSetting: (id) => http_requests.get(true, `${baseUrl}v1/account/settings/requests/${id}`),
  updateRequestSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/requests`, params),

  quoteSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/quotes`),
  updateQuoteSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/quotes`, params),

  invoiceSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/invoices`),
  updateInvoiceSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/invoices`, params),


  jobSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/jobs`),
  updateJobSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/jobs`, params),

  jobTypes: () => http_requests.get(true, `${baseUrl}v1/account/settings/job-types`),
  createJobType: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/job-types`, params),
  updateJobType: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/job-types/${id}`, params),
  deleteJobType: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/job-types/${id}`),

  jobStatuses: () => http_requests.get(true, `${baseUrl}v1/account/settings/job-statuses`),
  createJobStatus: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/job-statuses`, params),
  updateJobStatus: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/job-statuses/${id}`, params),
  deleteJobStatus: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/job-statuses/${id}`),


  roles: () => http_requests.get(true, `${baseUrl}v1/account/settings/roles`),
  createRole: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/roles`, params),
  updateRole: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/roles/${id}`, params),

  employees: () => http_requests.get(true, `${baseUrl}v1/account/settings/employees`),
  createEmployee: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/employees`, params),

  clientStatuses: () => http_requests.get(true, `${baseUrl}v1/account/settings/client-statuses`),
  createClientStatus: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/client-statuses`, params),
  updateClientStatus: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/client-statuses/${id}`, params),
  deleteClientStatus: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/client-statuses/${id}`),

  leadSources: () => http_requests.get(true, `${baseUrl}v1/account/settings/lead-sources`),
  createLeadSource: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/lead-sources`, params),
  updateLeadSource: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/lead-sources/${id}`, params),
  deleteLeadSource: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/lead-sources/${id}`),

  communicationSettings: () => http_requests.get(true, `${baseUrl}v1/account/settings/communication`),
  updateCommunicationSettings: (params) => http_requests.put(true, `${baseUrl}v1/account/settings/communication`, params),

  taxes: () => http_requests.get(true, `${baseUrl}v1/account/settings/price-book/taxes`),
  createTax: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/price-book/taxes`, params),
  updateTax: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/price-book/taxes/${id}`, params),
  deleteTax: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/taxes/${id}`),

  services: () => http_requests.get(true, `${baseUrl}v1/account/settings/price-book/services`),
  createService: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/price-book/services`, params),
  updateService: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/price-book/services/${id}`, params),
  deleteService: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/services/${id}`),
  uploadServiceImage: (id, file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/price-book/services/${id}/image`, file),
  deleteServiceImage: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/services/${id}/image`),

  materials: () => http_requests.get(true, `${baseUrl}v1/account/settings/price-book/materials`),
  createMaterial: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/price-book/materials`, params),
  updateMaterial: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/price-book/materials/${id}`, params),
  deleteMaterial: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/materials/${id}`),
  uploadMaterialImage: (id, file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/price-book/materials/${id}/image`, file),
  deleteMaterialImage: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/materials/${id}/image`),

  equipment: () => http_requests.get(true, `${baseUrl}v1/account/settings/price-book/equipment`),
  createEquipment: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/price-book/equipment`, params),
  updateEquipment: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/price-book/equipment/${id}`, params),
  deleteEquipment: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/equipment/${id}`),
  uploadEquipmentImage: (id, file) => http_requests.postFormData(true, `${baseUrl}v1/account/settings/price-book/equipment/${id}/image`, file),
  deleteEquipmentImage: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/equipment/${id}/image`),

  discountsFees: () => http_requests.get(true, `${baseUrl}v1/account/settings/price-book/discounts-fees`),
  getDiscounts: (type) => http_requests.get(true, `${baseUrl}v1/account/settings/price-book/discounts-fees?item_type=${type}`),
  createDiscountFee: (params) => http_requests.post(true, `${baseUrl}v1/account/settings/price-book/discounts-fees`, params),
  updateDiscountFee: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/price-book/discounts-fees/${id}`, params),
  deleteDiscountFee: (id) => http_requests.delete(true, `${baseUrl}v1/account/settings/price-book/discounts-fees/${id}`),
}

export const accountBilling = {
  changePlan: (params) => http_requests.put(true, `${baseUrl}v1/account/billing/subscription`, params),
}

export const employee = {
  details: (id) => http_requests.get(true, `${baseUrl}v1/account/settings/employees/${id}`),
  updateEmployee: (id, params) => http_requests.put(true, `${baseUrl}v1/account/settings/employees/${id}`, params),
}

export const clients = {
  statuses: () => http_requests.get(true, `${baseUrl}v1/account/settings/client-statuses`),
  getStatus: (id) => http_requests.get(true, `${baseUrl}v1/account/settings/client-statuses/${id}`),
  list: () => http_requests.get(true, `${baseUrl}v1/clients`),
  createClient: (params) => http_requests.post(true, `${baseUrl}v1/clients`, params),
  details: (id) => http_requests.get(true, `${baseUrl}v1/clients/${id}`),
  updateClient: (id, params) => http_requests.put(true, `${baseUrl}v1/clients/${id}`, params),
  updateContact: (id, params) => http_requests.put(true, `${baseUrl}v1/contacts/${id}`, params),
  makePrimaryContact: (id, params) => http_requests.put(true, `${baseUrl}v1/contacts/${id}/primary`, params),
  getContacts: (id) => http_requests.get(true, `${baseUrl}v1/contacts?client_id=${id}`),
  createContacts: (params) => http_requests.post(true, `${baseUrl}v1/contacts`, params),
  createAddresses: (params) => http_requests.post(true, `${baseUrl}v1/addresses`, params),
  getAddress: (id) => http_requests.get(true, `${baseUrl}v1/addresses?client_id=${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}v1/clients${queryString}`),
  deleteClient: (id) => http_requests.delete(true, `${baseUrl}v1/clients/${id}`),
  deleteContact: (id) => http_requests.delete(true, `${baseUrl}v1/contacts/${id}`),
  archiveClient: (id) => http_requests.delete(true, `${baseUrl}v1/clients/${id}/archive`),
  getRequests: (id) => http_requests.get(true, `${baseUrl}v1/requests?client_id=${id}`),
  getQuotes: (id) => http_requests.get(true, `${baseUrl}v1/quotes?client_id=${id}`),
}


export const addresses = {
  createAddress: (params) => http_requests.post(true, `${baseUrl}v1/addresses`, params),
  updateAddress: (id, params) => http_requests.put(true, `${baseUrl}v1/addresses/${id}`, params),
  deleteAddress: (id) => http_requests.delete(true, `${baseUrl}v1/addresses/${id}`),
  archiveAddress: (id) => http_requests.delete(true, `${baseUrl}v1/addresses/${id}/archive`),
  primaryAddress: (id) => http_requests.put(true, `${baseUrl}v1/addresses/${id}/primary`),
  billingAddress: (id) => http_requests.put(true, `${baseUrl}v1/addresses/${id}/billing`)
}

export const notes = {
  createNote: (params) => http_requests.post(true, `${baseUrl}v1/notes`, params),
  listNotes: (queryString) => http_requests.get(true, `${baseUrl}v1/notes${queryString}`),
  deleteNote: (id) => http_requests.delete(true, `${baseUrl}v1/notes/${id}`),
}

export const attachments = {
  createAttachment: (formData) => http_requests.postFormDataPrepared(true, `${baseUrl}v1/attachments`, formData),
  listAttachments: (queryString) => http_requests.get(true, `${baseUrl}v1/attachments${queryString}`),
  updateAttachment: (id, params) => http_requests.put(true, `${baseUrl}v1/attachments/${id}`, params),
  deleteAttachment: (id) => http_requests.delete(true, `${baseUrl}v1/attachments/${id}`),
  deleteAttachment: (id) => http_requests.delete(true, `${baseUrl}v1/attachments/${id}`),
  archiveAttachment: (id) => http_requests.delete(true, `${baseUrl}v1/attachments/${id}/archive`),
}

export const quotes = {
  list: () => http_requests.get(true, `${baseUrl}v1/quotes`),
  createQuote: (params) => http_requests.post(true, `${baseUrl}v1/quotes`, params),
  details: (id) => http_requests.get(true, `${baseUrl}v1/quotes/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}v1/quotes${queryString}`),
}

export const requests = {
  list: () => http_requests.get(true, `${baseUrl}v1/requests`),
  createQuote: (params) => http_requests.post(true, `${baseUrl}v1/requests`, params),
  details: (id) => http_requests.get(true, `${baseUrl}v1/requests/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}v1/requests${queryString}`),
  createRequest: (formData) => http_requests.postFormDataPrepared(true, `${baseUrl}v1/requests`, formData)
}

export const jobs = {
  list: () => http_requests.get(true, `${baseUrl}v1/jobs`),
  createJob: (params) => http_requests.post(true, `${baseUrl}v1/jobs`, params),
  details: (id) => http_requests.get(true, `${baseUrl}v1/jobs/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}v1/jobs${queryString}`),

  statuses: () => http_requests.get(true, `${baseUrl}v1/account/settings/job-statuses`),
}

export const invoices = {
  list: () => http_requests.get(true, `${baseUrl}v1/invoices`),
  createInvoice: (params) => http_requests.post(true, `${baseUrl}v1/invoices`, params),
  details: (id) => http_requests.get(true, `${baseUrl}v1/invoices/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}v1/invoices${queryString}`),
}

export const timeline = {
  client: (id) => http_requests.get(true, `${baseUrl}v1/timeline/clients/${id}`),
  request: (id) => http_requests.get(true, `${baseUrl}v1/timeline/requests/${id}`),
}